import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "../contexts/UserContext";

interface PrivateRouteProps {
  children: React.ReactNode;
  roles: string[];
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, roles }) => {
  const { user, userRole, isLoading } = useUser();

  useEffect(() => {
    // Re-render PrivateRoute when userRole changes
    // This ensures that the latest userRole is used for authorization
  }, [userRole]);

  if (isLoading) {
    return <div>Loading...</div>; // Display a loading state while checking
  }

  if (!user) {
    return <Navigate to="/login" replace />; // Redirect to login if unauthenticated
  }

  if (!userRole) {
    window.alert("User role is missing.");
    return <Navigate to="/unauthorized" replace />;
  }

  if (!roles.includes(userRole)) {
    window.alert("You are not authorized to access this page.");
    return <Navigate to="/unauthorized" replace />;
  }
   
  return <>{children}</>;
};

export default PrivateRoute;
